import { useFormSelector } from '../../../redux/formStoreHooks'
import { selectExport } from '../../../redux/selectForm'
import L3EncounterIds from '../l3-hardcode/L3EncounterIds'

const L4EncounterIds = () => {
	const exp = useFormSelector(state => selectExport(state))
	if(!exp) {
		return null
	}
	return (
		<L3EncounterIds
			cmsId={exp.Form.Member.CMSID}
			memberId={exp.Form.Member.MemberID}
			memberGuid={exp.Form.Member.Member_GUID}
			encounterGuid={exp.Form.Encounter.Encounter_GUID}
		/>
	)
}

export default L4EncounterIds
